(function () {
    'use strict';
    angular
        .module('invoices')
        .controller('CostCenterListController', CostCenterListController);
    CostCenterListController.$inject = ['$uibModal', '$state', '$stateParams', 'CostCenterService'];
    function CostCenterListController($uibModal, $state, $stateParams, CostCenterService) {
        var vm = this;
        vm.categoryName = '';
        vm.categoryList = '';
        vm.status = '';
        vm.query = [];
        vm.statusList = [{name:'Active',id:'active'}, {name:'Inactive',id:'inactive'}];

        vm.getInvoiceStatusLabel  = getInvoiceStatusLabel;
        vm.getInvoiceStatusClass  = getInvoiceStatusClass;
        vm.getCategory            = getCategory;
        vm.editCategory           = editCategory;
        vm.changeStatus           = changeStatus;
        vm.openSubcategoryModal   = openSubcategoryModal;
        vm.remove                 = remove;
        vm.selectOptionAll = [{
            name: '--- All ---'
        }];
        /* PAGINATION */
        vm.pageChanged  = pageChanged;
        vm.setPage      = setPage;
        vm.totalItems;
        vm.currentPage;
        vm.itemsPerPage;
        vm.page = 1;

        activate();

        function activate() {
            //vm.query['customer_id'] = 12042;
            vm.getCategory();
        }

        function getCategory() {
            vm.query['page'] = vm.page;
            CostCenterService.getInvoicesCostCenterCategory().then(function(response) {
                vm.categoryList = response.data.data;
                // vm.totalItems = response.data.total;
                // vm.to = response.data.to;
                // vm.itemsPerPage = response.data.per_page;
                // vm.setPage(response.data.current_page);
            }).catch(function(err) {
            });
        }

        function setPage(page) {
            vm.currentPage = page;
        }

        function pageChanged(page) {
            vm.page = vm.currentPage;
            vm.getCategory();
        }

        function getInvoiceStatusLabel(status) {
            return status;
        }

        function getInvoiceStatusClass(status) {
            if (status === 'Active') {
                return 'label-success';
            }
            return 'label-danger';
        }

        function remove(invoice) {
            alertify
                .confirm('This action is irreversible!')
                .set('labels', {
                    ok: 'Ok',
                    cancel: 'Cancelar'
                })
                .set('title', 'Do you really want to delete this invoice?')
                .set('onok', function (){
                    InvoicesService.destroy(invoice.id).then(function() {
                        vm.invoices.splice(vm.invoices.indexOf(invoice), 1);
                        alertify.notify('Invoice removed', 'success', 3);
                    });
                })
                .show();
        }

        function editCategory(category) {

        }

        function changeStatus(category) {

        }

        function openSubcategoryModal(category) {
            $uibModal.open({
                templateUrl: 'templates/invoices/cost-center/subcategoryModal/subcategoryModal.html',
                controller: 'CostCenterModalController',
                controllerAs:'subcategoryModal',
                resolve:
                    {
                        category : function () {
                            return category;
                        }
                    }
            });
        }
    }
})();